module.exports = __webpack_public_path__ + "img/events.333ac8af.svg";